const contactContainer = document.querySelector('.form-sec__contact-container');
if(contactContainer) {
  const tabs = document.querySelectorAll('.form-sec__contact-tab');
  const items = document.querySelectorAll('.form-sec__contact-item');

  function activateTab(index) {
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove('is-active');
      items[i].classList.remove('is-active');
    }
    tabs[index].classList.add('is-active');
    items[index].classList.add('is-active');
  }

  tabs.forEach((tab, idx) => {
    tab.addEventListener('click', () => activateTab(idx));
  })

  if (window.location.hash === '#employer') {
    activateTab(1);
  }
}